import { defineStore } from "pinia";
import { useHeaderDefinition } from "@movinglayers/navigation";
import { useI18n } from "vue-i18n";

export const useHeaderStore = defineStore("header", () => {
    const { t } = useI18n();
    return useHeaderDefinition({ title: t("header.map") });
});